export default __webpack_public_path__ + "static/media/Loader.9a6dbb4a.gif";